export class Sort {
    constructor(identifier, listaNodos, linea, columna) {
        this.linea = linea;
        this.columna = columna;
        this.identifier = identifier;
        this.listaNodos = listaNodos;
    }
}
